import React from "react";
import styled, { useTheme } from "styled-components";
import { LoadingSpinner, SpinnerSize } from "../../LoadingSpinner";
import { Text } from "../../Text";
import { DashboardItem } from "../DashboardItem/DashboardItem";
import { Flex } from "../../Flex";
import { DEFAULT_EMPTY_TEXT } from "../constants";
export const SingleKpi = (props) => {
    const { title, rowSpan, columnSpan, emptyText = DEFAULT_EMPTY_TEXT, value, isLoading = false } = props;
    const theme = useTheme();
    return (React.createElement(DashboardItem, { rowSpan: rowSpan, columnSpan: columnSpan },
        React.createElement(ComponentWrapper, null,
            title && React.createElement(Title, { as: "p" }, title),
            isLoading && React.createElement(LoadingSpinner, { size: SpinnerSize.SMALL }),
            !isLoading && React.createElement(Value, { as: "p" }, value),
            !isLoading && !value && (React.createElement(React.Fragment, null,
                React.createElement(EmptyIcon, { src: theme.svg.emptyStateSvg, alt: "Empty icon", role: "img" }),
                React.createElement(EmptyMessage, { as: "p" }, emptyText))))));
};
const ComponentWrapper = styled(Flex) `
  height: 100%;
  text-align: center;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  padding: ${({ theme: { space } }) => `${space[3]}px`};
`;
const Title = styled(Text) `
  margin: 0 0 12px;
  font-size: ${({ theme: { fontSizes } }) => `${fontSizes[1]}px`};
  font-weight: 300;
`;
const Value = styled(Text) `
  color: ${({ theme: { colors: { dashboardColors }, }, }) => dashboardColors.singleKpiValueText};
  margin: 0;
  font-size: ${({ theme: { fontSizes } }) => `${fontSizes[5]}px`};
  font-weight: 300;
  line-height: 1.36;
`;
const EmptyIcon = styled.img `
  width: 120px;
  height: 83px;
  padding-bottom: 12px;
`;
const EmptyMessage = styled(Text) `
  color: ${({ theme: { colors: { dashboardColors }, }, }) => dashboardColors.singleKpiEmptyText};
  margin: 0;
`;
